import styled from 'styled-components';
import AirportTransportIconSvg from '../../assets/hotels/amenities/Airport-transport.svg';

const AirportTransportIcon = styled(
  AirportTransportIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1,5rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default AirportTransportIcon;
